// "Something not working? Tell us" — on every page (docs/producto/MODELO_PRODUCTO_Y_ECONOMICO.md, §5).
// The message goes with where they were (the page, the trip, the browser); the owner gets an email.
import { useState } from "react";
import axios from "axios";
import { MessageSquare, X } from "lucide-react";
import { API } from "../utils/constants";

export default function FeedbackButton({ page, tripId, draftId, signedIn }) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");      // idle | sending | sent | error

  const send = async () => {
    if (message.trim().length < 3) return;
    setState("sending");
    const session = localStorage.getItem("jf_session");
    try {
      await axios.post(`${API}/feedback`, {
        message, email: signedIn ? "" : email,
        context: { page, trip: tripId || "", draft: draftId || "", url: window.location.href,
                   screen: `${window.innerWidth}x${window.innerHeight}`, browser: navigator.userAgent },
      }, { headers: session ? { Authorization: `Bearer ${session}` } : {} });
      setState("sent");
      setMessage("");
      setTimeout(() => { setOpen(false); setState("idle"); }, 2200);
    } catch {
      setState("error");
    }
  };

  return (
    <>
      <button onClick={() => setOpen(true)} aria-label="Send us feedback" data-testid="feedback-btn"
        className="fixed z-40 inline-flex items-center gap-1.5 hover:opacity-90"
        style={{ right: 0, top: "50%", transform: "translateY(-50%)", writingMode: "vertical-rl", rotate: "180deg",
                 padding: "12px 7px", borderRadius: "0 6px 6px 0", border: "1px solid var(--zen-border-h)", borderLeft: 0,
                 background: "var(--zen-s1)", color: "var(--zen-sub)", fontSize: 11.5, fontWeight: 600, cursor: "pointer",
                 letterSpacing: ".04em", boxShadow: "0 2px 10px rgba(0,0,0,.12)" }}>
        <MessageSquare className="w-3.5 h-3.5" style={{ rotate: "90deg" }} /> Feedback
      </button>
      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: "rgba(0,0,0,0.45)" }}
          onClick={e => e.target === e.currentTarget && setOpen(false)}>
          <div className="w-full max-w-sm p-5" style={{ background: "var(--zen-s1)", border: "1px solid var(--zen-border)", borderRadius: 8 }}
            data-testid="feedback-dialog">
            <div className="flex items-center justify-between mb-3">
              <h3 style={{ fontFamily: '"DM Sans", system-ui, sans-serif', fontWeight: 800, fontSize: 17, color: "var(--zen-text)" }}>
                Something not working?
              </h3>
              <button onClick={() => setOpen(false)} aria-label="Close" className="hover:opacity-70"
                style={{ background: "none", border: 0, color: "var(--zen-dim)", cursor: "pointer" }}><X className="w-4 h-4" /></button>
            </div>
            {state === "sent" ? (
              <p className="text-sm py-6 text-center" style={{ color: "var(--zen-sub)" }}>Thank you — we read every message.</p>
            ) : (
              <>
                <p className="text-xs mb-3" style={{ color: "var(--zen-sub)" }}>
                  Tell us what went wrong, or what you would change. We'll see which page you were on.
                </p>
                <textarea value={message} onChange={e => setMessage(e.target.value)} rows={5} autoFocus
                  placeholder="e.g. the map didn't open on day 3"
                  className="jf-field w-full mb-3" style={{ resize: "vertical" }} data-testid="feedback-message" />
                {!signedIn && (
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                    placeholder="Your email, if you'd like an answer" className="jf-field w-full mb-3" />
                )}
                {state === "error" && <p className="text-xs mb-2" style={{ color: "var(--cat-nightlife-solid)" }}>It didn't go through — try again in a moment.</p>}
                <button onClick={send} disabled={state === "sending" || message.trim().length < 3}
                  className="zen-btn zen-btn-primary w-full py-2.5" data-testid="feedback-send">
                  {state === "sending" ? "Sending..." : "Send"}
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
